/**
 * Utility Function: Used to remove classes on supplied targets
 * Loops through each supplied element and removes active classes supplied in argument
 * @param {object} resetOptions - Object containing targets to loop through and remove related classes
 */
export function resetStates(resetOptions) {
    Object.values(resetOptions).forEach((target) => {
        if (!target?.elements) return;

        // Check if target.elements is an array
        if (!Array.isArray(target.elements)) {
            console.error('target.elements is not an array:', target.elements);
            return;
        }

        target.elements.forEach((element) => {
            const classes = target.classes.split(' ');

            // Remove classes from the element
            element.classList.remove(...classes);

            if (!target.subElements) return;

            const subClasses = (target.subClasses || target.classes).split(' ');

            // Remove classes from the sub-elements
            element.querySelectorAll(target.subElements).forEach((subElement) => {
                subElement.classList.remove(...subClasses);
            });
        });
    });
}